export const instagramLink = "https://www.instagram.com/singervehicledesign/";
